import { useEffect, useState } from 'react'
import { isMobile } from '../../client'
import { useReelsBB } from '../../contexts/providers/ReelsBBProvider'
import { IVideo } from '../../types'
import { Container, Image, PlayButtonOverlay } from './Thumbnail.style'

const kalturaThumbnailurl =
  'https://cfvod.kaltura.com/p/2748741/sp/274874100/thumbnail/entry_id/'

type Props = {
  video: IVideo
  bbProps?: {
    anchorId: string
    index: number
    isTimeLine: boolean
    isBigBrother: boolean
  }
}

const BigBrotherThumbnail = ({ video }: Props) => {
  const [widthAndHeight, setWidthAndHeight] = useState('')

  const { handleShowPlayer } = useReelsBB()

  const handleClick = () => {
    handleShowPlayer(video.kalturaId)
  }

  useEffect(() => {
    const wandh = isMobile()
      ? 'width/300/height/169/type/3/quality/100'
      : 'width/224/height/126/type/3/quality/100'
    setWidthAndHeight(wandh)
  }, [])

  return (
    <Container onClick={handleClick}>
      <Image
        src={
          video.poster ||
          kalturaThumbnailurl +
            video.kalturaId +
            '/version/100101/' +
            widthAndHeight
        }
        alt={video.name}
      />
      <PlayButtonOverlay
        theme={{
          color: '#07c7dc',
        }}
      >
        <svg
          width='40'
          height='40'
          viewBox='0 0 40 40'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <rect width='40' height='40' rx='20' fillOpacity='0.6' />
          <path
            d='M29.0853 19.1443C29.7286 19.5334 29.7286 20.4666 29.0853 20.8557L16.2675 28.6084C15.6011 29.0115 14.75 28.5316 14.75 27.7527L14.75 12.2473C14.75 11.4684 15.6011 10.9885 16.2675 11.3916L29.0853 19.1443Z'
            fill='white'
          />
        </svg>
      </PlayButtonOverlay>
    </Container>
  )
}

export default BigBrotherThumbnail
